import { render } from "./MyQuotesList.vue?vue&type=template&id=c48533ba&scoped=true"
import script from "./MyQuotesList.vue?vue&type=script&lang=js"
export * from "./MyQuotesList.vue?vue&type=script&lang=js"

import "./MyQuotesList.vue?vue&type=style&index=0&id=c48533ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48533ba"]])

export default __exports__